import { render, staticRenderFns } from "./BoAboutUs.vue?vue&type=template&id=28a52709&"
import script from "./BoAboutUs.vue?vue&type=script&lang=js&"
export * from "./BoAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports